import React, { useState } from "react";
import PropTypes from "prop-types";
import { styled, Tab, Tabs, Tooltip } from "@mui/material";
import TabPanel from "../../../components/TabPanel/TabPanel";
import NativeFilter from "../../../components/NativeFilter/NativeFilter";
import CircleLoader from "../../../components/Loaders/CircleLoader";
import NativeObject from "../../../components/NativeObject/NativeObject";
import FilterMenu from "../../../components/FilterMenu/FilterMenu";

const LayoutWrapper = styled("div")({
  alignItems: "stretch",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "space-evenly",
  width: "100%",
});
const ButtonWrapper = styled("div")({
  button: {
    alignItems: "center",
    backgroundColor: "#fff",
    border: "1px solid #e6e6e6",
    borderRadius: "6px",
    display: "flex",
    padding: "8px 12px",
    span: {
      color: "#475257",
      fontSize: "10px",
      fontWeight: "800",
      letterSpacing: "0.15em",
      marginRight: "5px",
      textTransform: "uppercase",
      whiteSpace: "nowrap",
    },
    i: {
      color: "#475257",
      fontSize: "16px",
    },
    "&:hover": {
      backgroundColor: "#f2f4fd",
      span: { color: "#0190d2" },
      i: { color: "#0190d2" },
    },
  },
});

const LoaderWrapper = styled("div")({
  "& img": {
    maxWidth: "18px",
    maxHeight: "16px",
  },
});
function AnalisePdv({ app, config, index }) {
  const [loadingExcel, setLoadingExcel] = useState(false);

  const exportToXLS = async () => {
    setLoadingExcel(false);
    let id = "d80229e6-bd2a-49a0-bd74-99505101f070";
    const objectId = "d80229e6-bd2a-49a0-bd74-99505101f070";

    if (app && objectId) {
      setLoadingExcel(true);
      await app.visualization
        .get(objectId)
        .then((vis) => {
          id = vis.model.items.activeId;
        })
        .catch(() => setLoadingExcel(false));

      await app.visualization
        .get(id)
        .then((vis) => {
          vis.table.exportData({ format: "OOXML", state: "A" }).then((link) => {
            setLoadingExcel(false);
            const newLink = link;
            window.open(newLink);
          });
        })
        .catch(() => setLoadingExcel(false));
    }
  };

  return (
    <LayoutWrapper>
      <FilterMenu app={app} filters={config.app?.filters || {}} />

      <div
        style={{
          display: "flex",
          marginBottom: "12px",
          marginTop: "12px",
          justifyContent: "end",
        }}
      >
        <ButtonWrapper>
          <Tooltip title="EXPORTAR PARA EXCEL">
            <div>
              <button type="button" onClick={() => exportToXLS()}>
                {!loadingExcel ? (
                  <i className="far fa-file-export" />
                ) : (
                  <LoaderWrapper>
                    <CircleLoader />
                  </LoaderWrapper>
                )}
              </button>
            </div>
          </Tooltip>
        </ButtonWrapper>
      </div>

      <NativeObject
        app={app}
        reference={{ id: "d80229e6-bd2a-49a0-bd74-99505101f070" }}
        style={{ flex: 1, height: "100%" }}
        className="analisePDVs"
        type="table"
      />
    </LayoutWrapper>
  );
}

export default AnalisePdv;

AnalisePdv.defaultProps = {
  app: null,
  config: {},
  index: 0,
};

AnalisePdv.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
  index: PropTypes.number,
};
